import { Phone, Linkedin, Twitter, Facebook, Instagram, Youtube } from "lucide-react";
import { trackClick } from "@/lib/analytics";

// Inline WhatsApp icon (lucide doesn't have a brand icon)
const WhatsAppIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.15-.174.199-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.03 21.785h-.003a9.87 9.87 0 01-5.03-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c0-5.445 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.83 9.83 0 012.892 6.994c-.003 5.45-4.437 9.884-9.888 9.884zm8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.548 4.142 1.588 5.945L.057 24l6.305-1.654a11.876 11.876 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.5-8.413z"/>
  </svg>
);

export default function TopStrip() {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-neutral-950 text-white/90 text-xs"
      data-testid="top-strip"
    >
      <div className="max-w-[95vw] mx-auto flex items-center justify-between gap-4 h-9 px-4">
        {/* Left: language + flags */}
        <div className="flex items-center gap-3">
          <button className="flex items-center gap-1.5 hover:text-white transition-colors" data-testid="lang-en">
            <img src="https://flagcdn.com/w40/gb.png" alt="United Kingdom" className="w-4 h-3 rounded-[2px] object-cover" />
            <span className="hidden sm:inline">GB</span>
          </button>
          <span className="w-px h-3 bg-white/20" />
          <button className="flex items-center gap-1.5 hover:text-white transition-colors" data-testid="lang-pk">
            <img src="https://flagcdn.com/w40/pk.png" alt="Pakistan" className="w-4 h-3 rounded-[2px] object-cover" />
            <span className="hidden sm:inline">PK</span>
          </button>
        </div>

        {/* Center: WhatsApp + phones */}
        <div className="flex items-center gap-3 md:gap-5 text-white/85">
          <a
            href="https://wa.me/447380885506"
            target="_blank"
            rel="noreferrer"
            className="hidden sm:flex items-center gap-1.5 hover:text-white transition-colors"
            data-testid="whatsapp-uk"
            onClick={() => trackClick("whatsapp_clicked", { number: "+447380885506", surface: "top_strip", market: "uk" })}
          >
            <WhatsAppIcon className="w-3.5 h-3.5 text-emerald-400" />
            <span className="hidden md:inline">+44 73 8088 5506</span>
          </a>
          <span className="hidden md:inline w-px h-3 bg-white/20" />
          <a
            href="https://wa.me/923455222000"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1.5 hover:text-white transition-colors"
            data-testid="whatsapp-pk"
            onClick={() => trackClick("whatsapp_clicked", { number: "+923455222000", surface: "top_strip", market: "pk" })}
          >
            <WhatsAppIcon className="w-3.5 h-3.5 text-emerald-400" />
            <span className="hidden sm:inline">+92 345 5222 000</span>
          </a>
        </div>

        {/* Right: socials */}
        <div className="flex items-center gap-3 text-white/70">
          <a href="https://linkedin.com/company/cloudlabweb" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="hover:text-white" data-testid="social-linkedin"><Linkedin className="w-3.5 h-3.5" /></a>
          <a href="https://x.com/cloudlabweb"          target="_blank" rel="noreferrer" aria-label="X"        className="hover:text-white" data-testid="social-twitter"><Twitter  className="w-3.5 h-3.5" /></a>
          <a href="https://facebook.com/cloudlabweb"    target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-white" data-testid="social-facebook"><Facebook className="w-3.5 h-3.5" /></a>
          <a href="https://instagram.com/cloudlabweb"   target="_blank" rel="noreferrer" aria-label="Instagram"className="hover:text-white" data-testid="social-instagram"><Instagram className="w-3.5 h-3.5" /></a>
          <a href="https://youtube.com/@cloudlabweb"    target="_blank" rel="noreferrer" aria-label="YouTube" className="hover:text-white" data-testid="social-youtube"><Youtube className="w-3.5 h-3.5" /></a>
        </div>
      </div>
    </div>
  );
}
